export default __webpack_public_path__ + "static/media/Menu.4e735f7c.svg";